<template>
  <div class="banner-section">
    <!-- 轮播图容器 -->
    <div class="banner-carousel">
      <div class="carousel-container" ref="carouselContainer">
        <div
          class="carousel-item"
          v-for="(image, index) in bannerImages"
          :key="index"
          :class="{ active: currentIndex === index }"
        >
          <img :src="image.url" :alt="image.alt" />
        </div>
      </div>

      <!-- 轮播指示器 -->
      <div class="carousel-indicators">
        <span
          v-for="(image, index) in bannerImages"
          :key="index"
          class="indicator"
          :class="{ active: currentIndex === index }"
          @click="goToSlide(index)"
        ></span>
      </div>

      <!-- 轮播控制按钮 -->
      <button class="carousel-btn prev" @click="prevSlide">
        <span>&lt;</span>
      </button>
      <button class="carousel-btn next" @click="nextSlide">
        <span>&gt;</span>
      </button>
    </div>

    <!-- 用户资料框容器 -->
    <div class="user-panel-container">
      <div class="user-panel">
        <!-- 登录/注册/重置密码表单，未登录时只显示一个 -->
        <template v-if="!isLoggedIn">
          <div v-if="mode === 'login'" class="login-form">
          <div class="form-title">
            <div
              class="title-item"
              v-for="item in loginSelect"
              :key="item.id"
              @click="selectFunction(item.id)"
              :class="{ choseItem: fristId == item.id }"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="form-item">
            <input v-model="loginForm.username" type="text" placeholder="请输入手机号" />
          </div>
          <div class="form-item">
            <input v-model="loginForm.password" type="password" placeholder="请输入密码" />
          </div>
          <div class="form-item-auth">
            <input v-model="loginForm.captcha" type="text" placeholder="请输入图形验证码" />
              <div class="captcha-image" style="width: 174px; height: 48px; display: flex; align-items: center; justify-content: flex-end;">
                <img v-if="captchaUrlWithPrefix" :src="captchaUrlWithPrefix" @click="refreshCaptcha" style="width: 174px; height: 48px; cursor: pointer;" alt="验证码" />
            </div>
          </div>
          <div class="password-options">
            <label class="remember-me">
              <input type="checkbox" v-model="rememberPassword" />
              记住密码
            </label>
              <a href="#" class="forgot-password" @click.prevent="mode='reset'">忘记密码</a>
          </div>
          <button class="login-btn" @click="handleLogin">登录</button>
          <div class="register-link">
            <span>没有账号？</span>
              <button type="button" class="register-link-btn" @click="mode='register'">立即注册</button>
          </div>
        </div>
          <div v-else-if="mode === 'register'" class="register-form">
            <h2 class="form-title">注册账号</h2>
            <div class="form-item">
              <input v-model="registerForm.phone" type="text" placeholder="请输入常用手机号" />
            </div>
            <div class="form-item">
              <input v-model="registerForm.password" type="password" placeholder="请设置密码" />
            </div>
            <div class="form-item">
              <input v-model="registerForm.confirmPassword" type="password" placeholder="再次确认密码" />
            </div>
            <div class="form-item-sms">
              <input v-model="registerForm.smsCaptcha" type="text" placeholder="请输入短信验证码" />
              <button class="sms-btn" @click="sendSmsCaptcha" :disabled="smsCountdown > 0">{{ smsButtonText }}</button>
            </div>
            <button class="login-btn" @click="handleRegister">注册账号</button>
            <div class="register-link">
              <span>已有助力通账号：</span>
              <button type="button" class="register-link-btn" @click="mode='login'">直接登录</button>
            </div>
          </div>
          <div v-else-if="mode === 'reset'" class="reset-form">
            <h2 class="form-title">重置密码</h2>
            <div class="form-item">
              <input v-model="resetForm.phone" type="text" placeholder="请输入常用手机号" />
            </div>
            <div class="form-item">
              <input v-model="resetForm.password" type="password" placeholder="请设置密码" />
            </div>
            <div class="form-item">
              <input v-model="resetForm.confirmPassword" type="password" placeholder="再次确认密码" />
            </div>
            <div class="form-item-auth">
              <input v-model="resetForm.imgCaptcha" type="text" placeholder="请输入图形验证码" />
              <div class="captcha-image" style="width: 174px; height: 48px; display: flex; align-items: center; justify-content: flex-end;">
                <img v-if="captchaUrlWithPrefix" :src="captchaUrlWithPrefix" @click="refreshCaptcha" style="width: 174px; height: 48px; cursor: pointer;" alt="验证码" />
              </div>
            </div>
            <div class="form-item-sms">
              <input v-model="resetForm.smsCaptcha" type="text" placeholder="请输入短信验证码" />
              <button class="sms-btn" @click="sendSmsCaptcha" :disabled="smsCountdown > 0">{{ smsButtonText }}</button>
            </div>
            <button class="login-btn" @click="handleReset">重置密码</button>
            <div class="register-link">
              <span>已经记起密码了？</span>
              <button type="button" class="register-link-btn" @click="mode='login'">返回登录</button>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="logged-in-content">
          <div class="user-header">
            <div class="user-info">
              <div class="avatar">
                {{ avatarText }}
              </div>
                <h3>{{ currentUser.username }}</h3>
            </div>
            <button class="logout-btn" @click="handleLogout">安全退出</button>
          </div>

          <div class="order-dashboard">
            <div class="order-item" v-for="item in orderData" :key="item.label">
              <div class="label">{{ item.label }}</div>
              <div class="value">{{ item.value }}</div>
            </div>
          </div>

          <div class="action-buttons">
            <button class="action-btn" @click="goToBackend">进入后台</button>
            <button class="action-wed" @click="goToWebsite">我的网站</button>
          </div>
        </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus';
import { getLogin, getRegister, getVerificationCode, getVerifyCode, getForgetPassword, getHzLogin, getHzRegister, getHzVerificationCode, getHzVerifyCode, getHzForgetPassword, getWuliuLogisticsInfo, getHuozhuLogisticsInfo, getCompanyDataSta, getHzCompanyDataSta } from '@/apis/modules/login/login.js';
import { getBannerList } from '@/apis/modules/banner/index.js';
import { getHost } from '@/utils/domain.js';

export default {
  name: 'BannerSection',
  data() {
    return {
      // 轮播图数据
      bannerImages: [],
      currentIndex: 0,
      autoPlayTimer: null,

      loginSelect: [
        { id: 1, name: '货主登录' },
        { id: 2, name: '物流登录' }
      ],
      fristId: 1,
      isLoggedIn: false,
      rememberPassword: false,
      // 货主表单数据
      huozhuLoginForm: {
        username: '',
        password: '',
        captcha: ''
      },
      huozhuRegisterForm: {
        phone: '',
        password: '',
        confirmPassword: '',
        smsCaptcha: ''
      },
      huozhuResetForm: {
        phone: '',
        password: '',
        confirmPassword: '',
        imgCaptcha: '',
        smsCaptcha: ''
      },
      // 物流表单数据
      wuliuLoginForm: {
        username: '',
        password: '',
        captcha: ''
      },
      wuliuRegisterForm: {
        phone: '',
        password: '',
        confirmPassword: '',
        smsCaptcha: ''
      },
      wuliuResetForm: {
        phone: '',
        password: '',
        confirmPassword: '',
        imgCaptcha: '',
        smsCaptcha: ''
      },
      captchaText: 'M8k2',
      currentUser: {
        username: '',
        token: ''
      },
      orderData: [
        { label: '在途订单', value: '0单' },
        { label: '今天订单量', value: '0单' },
        { label: '昨日订单量', value: '0单' },
        { label: '异常订单', value: '0单' },
        { label: '总订单量', value: '0单' },
        { label: '总订单金额', value: '¥0,00' }
      ],
      // 分类列表请求参数
      BannerListParams: {
        pageNo: 1,
        pageSize: 10
      },
      mode: 'login', // 控制登录/注册表单的显示
      // 短信验证码倒计时
      smsCountdown: 0,
      smsTimer: null,
    }
  },
  computed: {
    avatarText() {
      return this.currentUser.username.charAt(0)
    },
    captchaUrlWithPrefix() {
      if (!this.captchaText) return ''
      if (this.captchaText.startsWith('data:image')) {
        return this.captchaText
      }
      return `data:image/png;base64,${this.captchaText}`
    },
    // 根据当前登录类型返回对应的表单数据
    loginForm() {
      return this.fristId === 1 ? this.huozhuLoginForm : this.wuliuLoginForm
    },
    registerForm() {
      return this.fristId === 1 ? this.huozhuRegisterForm : this.wuliuRegisterForm
    },
    resetForm() {
      return this.fristId === 1 ? this.huozhuResetForm : this.wuliuResetForm
    },
    // 短信按钮文本
    smsButtonText() {
      return this.smsCountdown > 0 ? `${this.smsCountdown}s` : '发送验证码'
    }
  },
  // 验证码图片
  created() {
    this.refreshCaptcha()
    this.checkLoginStatus()
    const userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      try {
        const userData = JSON.parse(userInfo)
        if (userData.userType === 'huozhu') this.fristId = 1
        else if (userData.userType === 'wuliu') this.fristId = 2
      } catch (e) {}
    }
  },
  watch: {
    // 监听表单模式变化，切换时刷新验证码
    mode: {
      handler(newMode) {
        if (newMode === 'login' || newMode === 'reset') {
          this.refreshCaptcha()
        }
      },
      immediate: false
    }
  },

  async mounted() {
    this.startAutoPlay();
    try {
      const res = await getBannerList({ ...this.BannerListParams, host: getHost() });
      if (res && res.data && Array.isArray(res.data.records)) {
        const images = res.data.records
          .map(record => (record.banners && record.banners[0] && record.banners[0].pic) || null)
          .filter(Boolean)
          .map(pic => ({ url: pic, alt: '' }));
        if (images.length > 0) {
          this.bannerImages = images;
        }
      }
    } catch (e) {}
  },
  beforeUnmount() {
    this.stopAutoPlay()
    // 清理短信验证码定时器
    if (this.smsTimer) {
      clearInterval(this.smsTimer)
      this.smsTimer = null
    }
  },
  methods: {
    // 切换到下一个轮播图
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.bannerImages.length
    },
    // 切换到上一个轮播图
    prevSlide() {
      this.currentIndex =
        this.currentIndex === 0
          ? this.bannerImages.length - 1
          : this.currentIndex - 1
    },
    // 跳转到指定轮播图
    goToSlide(index) {
      this.currentIndex = index
    },
    // 开始自动轮播
    startAutoPlay() {
      this.autoPlayTimer = setInterval(() => {
        this.nextSlide()
      }, 5000)
    },
    // 停止自动轮播
    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer)
        this.autoPlayTimer = null
      }
    },
    // 选择登录类型
    async selectFunction(id) {
      this.fristId = id
      // 切换登录类型后，重新请求对应的验证码
      await this.refreshCaptcha()
    },
    // 刷新验证码图片
    async refreshCaptcha() {
      let res
      if (this.fristId === 1) {
        res = await getHzVerifyCode({})
      } else {
        res = await getVerifyCode({})
      }
      if (res && res.statusMsg) {
        this.captchaText = res.statusMsg
      } else {
        this.captchaText = ''
      }
    },
    // 登录方法
    async handleLogin() {
      // 物流或货主登录
      const params = {
        phoneNumber: this.loginForm.username,
        password: this.loginForm.password,
        valid: this.loginForm.captcha,
        gender: this.rememberPassword
      }
      let res
      if (this.fristId === 1) {
        // 货主登录
        res = await getHzLogin(params)
      } else {
        // 物流登录
        res = await getLogin(params)
      }
      if (res && res.statusCode === 20000) {
        // 保存token和用户信息到本地
        const userData = {
          username: this.loginForm.username || '新用户',
          token: res.data.token,
          isQiYeAccount: res.data.isQiYeAccount,
          userType: this.fristId === 1 ? 'huozhu' : 'wuliu'
        }
        localStorage.setItem('userInfo', JSON.stringify(userData))

        this.isLoggedIn = true
        this.currentUser.username = userData.username
        this.currentUser.token = userData.token

        // 登录成功后获取统计数据
        await this.fetchOrderStatistics()

        // 触发自定义事件通知Header组件更新
        window.dispatchEvent(new Event('userLoginChange'))

        ElMessage.success('登录成功')
      } else {
        console.log('66')
        ElMessage.error(res.statusMsg || '登录失败')
        this.refreshCaptcha()
      }
    },
    // 注册方法
    async handleRegister() {
      // 本地校验两次密码
      if (this.registerForm.password !== this.registerForm.confirmPassword) {
        ElMessage.error('两次输入的密码不一致，请重新输入！')
        return
      }
      const params = {
        phoneNumber: this.registerForm.phone,
        password: this.registerForm.password,
        msgvalid: this.registerForm.smsCaptcha
      }
      let res
      if (this.fristId === 1) {
        res = await getHzRegister(params)
      } else {
        res = await getRegister(params)
      }
      if (res && res.statusCode === 20000) {
        ElMessage.success('注册成功')
        this.mode = 'login'
      } else {
        ElMessage.error(res.statusMsg || '注册失败')
      }
    },
    // 重置密码方法
    async handleReset() {
      // 本地校验两次密码
      if (this.resetForm.password !== this.resetForm.confirmPassword) {
        ElMessage.error('两次输入的密码不一致，请重新输入！')
        return
      }
      const params = {
        phoneNumber: this.resetForm.phone,
        password: this.resetForm.password,
        valid: this.resetForm.imgCaptcha,
        verificationCode: this.resetForm.smsCaptcha
      }
      let res
      if (this.fristId === 1) {
        res = await getHzForgetPassword(params)
      } else {
        res = await getForgetPassword(params)
      }
      if (res && res.statusCode === 20000) {
        ElMessage.success('重置成功')
        this.mode = 'login'
      } else {
        ElMessage.error(res.statusMsg || '重置失败')
        this.refreshCaptcha()
      }
    },
    // 验证电话号码格式
    validatePhoneNumber(phone) {
      const phoneRegex = /^1[3-9]\d{9}$/
      return phoneRegex.test(phone)
    },
    // 发送短信验证码
    async sendSmsCaptcha() {
      // 如果正在倒计时，不允许发送
      if (this.smsCountdown > 0) {
        return
      }

      // 根据当前模式获取电话号码
      let phoneNumber = ''
      if (this.mode === 'register') {
        phoneNumber = this.registerForm.phone
      } else if (this.mode === 'reset') {
        phoneNumber = this.resetForm.phone
      }

      // 验证电话号码
      if (!phoneNumber) {
        ElMessage.error('请输入电话号码')
        return
      }

      if (!this.validatePhoneNumber(phoneNumber)) {
        ElMessage.error('请输入正确的电话号码')
        return
      }

      let params = {}
      if (this.mode === 'register') {
        params = {
          phoneNumber: this.registerForm.phone,
          valid: this.registerForm.imgCaptcha
        }
        if (this.fristId === 1) {
          await getHzVerificationCode(params)
        } else {
          await getVerificationCode(params)
        }
      } else if (this.mode === 'reset') {
        params = {
          phoneNumber: this.resetForm.phone,
          valid: this.resetForm.imgCaptcha
        }
        if (this.fristId === 1) {
          await getHzVerificationCode(params)
        } else {
          await getVerificationCode(params)
        }
      }
      this.startSmsCountdown()
      ElMessage.success('验证码已发送')
    },
    // 开始短信验证码倒计时
    startSmsCountdown() {
      this.smsCountdown = 60
      this.smsTimer = setInterval(() => {
        this.smsCountdown--
        if (this.smsCountdown <= 0) {
          clearInterval(this.smsTimer)
          this.smsTimer = null
        }
      }, 1000)
    },
    // 退出登录
    handleLogout() {
      this.isLoggedIn = false
      // 清空所有表单数据
      this.huozhuLoginForm = { username: '', password: '', captcha: '' }
      this.huozhuRegisterForm = { phone: '', password: '', confirmPassword: '', smsCaptcha: '' }
      this.huozhuResetForm = { phone: '', password: '', confirmPassword: '', imgCaptcha: '', smsCaptcha: '' }
      this.wuliuLoginForm = { username: '', password: '', captcha: '' }
      this.wuliuRegisterForm = { phone: '', password: '', confirmPassword: '', smsCaptcha: '' }
      this.wuliuResetForm = { phone: '', password: '', confirmPassword: '', imgCaptcha: '', smsCaptcha: '' }
      this.currentUser = { username: '', token: '' }
      localStorage.removeItem('userInfo')
      this.refreshCaptcha()

      // 触发自定义事件通知Header组件更新
      window.dispatchEvent(new Event('userLogoutChange'))
    },
    // 跳转到后台系统
    goToBackend() {
      const userInfo = localStorage.getItem('userInfo')
      if (!userInfo) {
        ElMessage.error('用户信息不存在，请重新登录')
        return
      }

      try {
        const userData = JSON.parse(userInfo)
        const { token, isQiYeAccount } = userData

        let url
        if (this.fristId === 1) {
          // 货主登录
          const params = new URLSearchParams({
            token: token,
            isQiYeAccount: isQiYeAccount ? '1' : '0'
          })
          url = `https://www.zhult.com/huozhu/#/login?${params.toString()}`
        } else {
          // 物流登录
          const params = new URLSearchParams({
            token: token,
            isQiYeAccount: isQiYeAccount ? '1' : '0'
          })
          url = `https://www.zhult.com/wuliu/#/login?${params.toString()}`
        }

        window.open(url, '_blank')
        ElMessage.success('正在跳转后台系统...')
      } catch (error) {
        console.error('解析用户信息失败:', error)
        ElMessage.error('用户信息解析失败，请重新登录')
      }
    },
    // 跳转到个人网站（货主/物流）
    async goToWebsite() {
      const userInfo = localStorage.getItem('userInfo')
      if (!userInfo) {
        ElMessage.error('用户信息不存在，请重新登录')
        return
      }

      try {
        if (this.fristId === 1) {
          // 货主登录 - 请求货主网站信息
          try {
            const res = await getHuozhuLogisticsInfo({})
            console.log('货主网站信息请求结果:', res)
            if (res && res.data && res.data.adHost && res.data.adHost.trim() !== '') {
              const url = `https://${res.data.adHost}.zhult.com/hz/#/`
              window.open(url, '_blank')
            } else {
              ElMessage.error('还未配置网站编码')
            }
          } catch (error) {
            console.error('请求货主网站信息失败:', error)
            ElMessage.error('获取货主网站信息失败')
          }
        } else {
          // 物流登录 - 请求物流网站信息
          try {
            const res = await getWuliuLogisticsInfo({})
            console.log('物流网站信息请求结果:', res)
            if (res && res.data && res.data.adHost && res.data.adHost.trim() !== '') {
              const url = `https://${res.data.adHost}.zhult.com/wl/#/`
              window.open(url, '_blank')
            } else {
              ElMessage.error('还未配置网站编码')
            }
          } catch (error) {
            console.error('请求物流网站信息失败:', error)
            ElMessage.error('获取物流网站信息失败')
          }
        }
      } catch (error) {
        console.error('解析用户信息失败:', error)
        ElMessage.error('用户信息解析失败，请重新登录')
      }
    },
    // 检查本地是否有token并设置登录状态
    async checkLoginStatus() {
      const userInfo = localStorage.getItem('userInfo')
      if (userInfo) {
        try {
          const userData = JSON.parse(userInfo)
          if (userData.token) {
            this.isLoggedIn = true
            this.currentUser.username = userData.username
            this.currentUser.token = userData.token

            // 如果已登录，获取统计数据
            await this.fetchOrderStatistics()
          }
        } catch (error) {
          console.error('解析用户信息失败:', error)
          localStorage.removeItem('userInfo')
        }
      }
    },
    // 获取banner图片（未使用）
    async fetchBannerImages() {
      try {
        const res = await getBannerList({ page: 1, size: 10, host: getHost() });
      } catch (e) {}
    },
    // 获取订单统计数据
    async fetchOrderStatistics() {
      try {
        const userInfo = localStorage.getItem('userInfo')
        if (!userInfo) {
          ElMessage.error('用户信息不存在，请重新登录')
          return
        }

        let res
        if (this.fristId === 1) {
          // 货主统计
          res = await getHzCompanyDataSta({})
        } else {
          // 物流统计
          res = await getCompanyDataSta({})
        }

        if (res && res.statusCode === 20000 && res.data) {
          const data = res.data
          this.orderData = [
            { label: '在途订单', value: `${data.orderIngCount || 0}单` },
            { label: '今天订单量', value: `${data.orderTodayCount || 0}单` },
            { label: '昨日订单量', value: `${data.orderYesterdayCount || 0}单` },
            { label: '异常订单', value: `${data.orderErrorCount || 0}单` },
            { label: '总订单量', value: `${data.orderSumCount || 0}单` },
            { label: '总订单金额', value: `¥${data.orderSumMoney || 0}` }
          ]
        }
      } catch (error) {
        console.error('获取订单统计数据失败:', error)
        ElMessage.error('获取订单统计数据失败')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.banner-section {
  width: 100%;
  height: 562px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  .banner-carousel {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    .carousel-container {
      width: 100%;
      height: 100%;
      position: relative;

      .carousel-item {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        transition: opacity 0.5s ease-in-out;

        &.active {
          opacity: 1;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    .carousel-indicators {
      position: absolute;
      bottom: 60px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      gap: 10px;
      z-index: 3;

      .indicator {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.5);
        cursor: pointer;
        transition: background 0.3s ease;

        &.active {
          background: #fff;
        }

        &:hover {
          background: rgba(255, 255, 255, 0.8);
        }
      }
    }

    .carousel-btn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 40px;
      height: 40px;
      background: rgba(0, 0, 0, 0.3);
      border: none;
      border-radius: 50%;
      color: white;
      font-size: 18px;
      cursor: pointer;
      z-index: 3;
      transition: background 0.3s ease;

      &:hover {
        background: rgba(0, 0, 0, 0.6);
      }

      &.prev {
        left: 20px;
      }

      &.next {
        right: 20px;
      }
    }
  }

  .user-panel-container {
    width: 1400px;
    display: flex;
    justify-content: flex-end;
    position: relative;
    z-index: 2;

    .user-panel {
      display: flex;
      flex-direction: column;
      width: 420px;
      min-height: 440px;
      height: auto;
      background: #ffffff;
      box-shadow: 0px 8px 48px 0px rgba(0, 23, 77, 0.1);
      box-sizing: border-box;
      margin-bottom: 24px;

      .login-form {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 24px;
        text-align: center;

        .form-title {
          width: 396px;
          height: 40px;
          box-sizing: border-box;
          border-width: 0px 0px 1px 0px;
          border-style: solid;
          border-color: rgba(0, 27, 81, 0.4);
          display: flex;
          margin-bottom: 16px;

          .title-item {
            font-family: PingFang SC;
            font-size: 20px;
            font-weight: 500;
            line-height: 30px;
            letter-spacing: normal;
            color: rgba(0, 27, 81, 0.4);
            margin-right: 24px;
            cursor: pointer;
          }

          .choseItem {
            color: #001b51;
            border-width: 0px 0px 4px 0px;
            border-style: solid;
            border-color: rgba(0, 27, 81, 1);
          }
        }

        .form-item {
          margin-bottom: 16px;
          input {
            width: 372px;
            height: 48px;
            border-radius: 4px;
            background: #f2f2f2;
            padding: 12px 0px 12px 24px;
            box-sizing: border-box;
            border: none;
            outline: none;
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: normal;
            line-height: 24px;
            letter-spacing: normal;
            color: rgba(0, 27, 81, 0.6);
          }
        }

        .form-item-auth {
          margin-bottom: 8px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-sizing: border-box;

          input {
            width: 182px;
            height: 48px;
            border-radius: 4px;
            background: #f2f2f2;
            padding: 12px 0px 12px 24px;
            box-sizing: border-box;
            border: none;
            outline: none;
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: normal;
            line-height: 24px;
            letter-spacing: normal;
            color: rgba(0, 27, 81, 0.6);
          }

          .captcha-image {
            width: 174px;
            height: 48px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgb(242, 242, 242, 1);
            cursor: pointer;
          }
        }

        .password-options {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .remember-me {
            display: flex;
            align-items: center;
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: normal;
            line-height: 24px;
            letter-spacing: normal;
            color: #001b51;
            input {
              margin-right: 8px;
              width: 16px;
              height: 16px;
              background: #ffffff;
              box-sizing: border-box;
              border: 1px solid rgba(0, 21, 63, 0.2);
            }
          }

          .forgot-password {
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: normal;
            line-height: 24px;
            letter-spacing: normal;
            color: #005dff;
            text-decoration: none;
          }
        }

        .login-btn {
          width: 100%;
          height: 45px;
          background: #001b51;
          color: white;
          border: none;
          border-radius: 4px;
          margin-top: 24px;
          margin-bottom: 24px;
          cursor: pointer;
        }

        .register-link {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          font-size: 18px;
          span {
            font-family: PingFang SC;
            font-size: 18px;
            font-weight: normal;
            line-height: 24px;
            letter-spacing: normal;
            color: #001b51;
          }

          .register-link-btn {
            font-family: PingFang SC;
            font-size: 18px;
            font-weight: 500;
            line-height: 24px;
            letter-spacing: normal;
            color: #005dff;
            text-decoration: none;
            background: none;
            border: none;
            cursor: pointer;
          }
        }
      }

      .register-form {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 24px;
        text-align: center;

        .form-title {
          width: 396px;
          height: 40px;
          box-sizing: border-box;
          border-width: 0px 0px 1px 0px;
          border-style: solid;
          border-color: rgba(0, 27, 81, 0.4);
          display: flex;
          margin-bottom: 16px;
          font-family: PingFang SC;
          font-size: 20px;
          font-weight: 500;
          line-height: 30px;
          letter-spacing: normal;
          color: rgba(0, 27, 81, 0.4);
        }

        .form-item {
          margin-bottom: 16px;

          input {
            width: 372px;
            height: 48px;
            border-radius: 4px;
            background: #f2f2f2;
            padding: 12px 0px 12px 24px;
            box-sizing: border-box;
            border: none;
            outline: none; //移除聚焦时的默认边框
            //字体
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: normal;
            line-height: 24px;
            letter-spacing: normal;
            color: rgba(0, 27, 81, 0.6);
          }
        }

        .form-item-sms {
          margin-bottom: 8px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-sizing: border-box;

          input {
            width: 182px;
            height: 48px;
            border-radius: 4px;
            background: #f2f2f2;
            padding: 12px 0px 12px 24px;
            box-sizing: border-box;
            border: none;
            outline: none;
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: normal;
            line-height: 24px;
            letter-spacing: normal;
            color: rgba(0, 27, 81, 0.6);
          }

          .sms-btn {
            width: 100px;
            height: 48px;
            background: #005dff;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: 500;
            line-height: 24px;
            letter-spacing: normal;

            &:disabled {
              background: #ccc;
              cursor: not-allowed;
            }
          }
        }

        .login-btn {
          width: 100%;
          height: 45px;
          background: #001b51;
          color: white;
          border: none;
          border-radius: 4px;
          margin-top: 24px;
          margin-bottom: 24px;
          cursor: pointer;
        }

        .register-link {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          font-size: 18px;

          span {
            font-family: PingFang SC;
            font-size: 18px;
            font-weight: normal;
            line-height: 24px;
            letter-spacing: normal;
            color: #001b51;
          }

          .register-link-btn {
            font-family: PingFang SC;
            font-size: 18px;
            font-weight: 500;
            line-height: 24px;
            letter-spacing: normal;
            color: #005dff;
            text-decoration: none;
            background: none;
            border: none;
            cursor: pointer;
          }
        }
      }

      .reset-form {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 24px;
        text-align: center;

        .form-title {
          width: 396px;
          height: 40px;
          box-sizing: border-box;
          border-width: 0px 0px 1px 0px;
          border-style: solid;
          border-color: rgba(0, 27, 81, 0.4);
          display: flex;
          margin-bottom: 16px;
          font-family: PingFang SC;
          font-size: 20px;
          font-weight: 500;
          line-height: 30px;
          letter-spacing: normal;
          color: rgba(0, 27, 81, 0.4);
        }

        .form-item {
          margin-bottom: 16px;

          input {
            width: 372px;
            height: 48px;
            border-radius: 4px;
            background: #f2f2f2;
            padding: 12px 0px 12px 24px;
            box-sizing: border-box;
            border: none;
            outline: none;
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: normal;
            line-height: 24px;
            letter-spacing: normal;
            color: rgba(0, 27, 81, 0.6);
          }
        }

        .form-item-auth {
          margin-bottom: 8px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-sizing: border-box;

          input {
            width: 182px;
            height: 48px;
            border-radius: 4px;
            background: #f2f2f2;
            padding: 12px 0px 12px 24px;
            box-sizing: border-box;
            border: none;
            outline: none;
            //字体
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: normal;
            line-height: 24px;
            letter-spacing: normal;
            color: rgba(0, 27, 81, 0.6);
          }

          .captcha-image {
            width: 174px;
            height: 48px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgb(242, 242, 242, 1);
            cursor: pointer;
          }
        }

        .form-item-sms {
          margin-bottom: 8px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-sizing: border-box;

          input {
            width: 182px;
            height: 48px;
            border-radius: 4px;
            background: #f2f2f2;
            padding: 12px 0px 12px 24px;
            box-sizing: border-box;
            border: none;
            outline: none;
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: normal;
            line-height: 24px;
            letter-spacing: normal;
            color: rgba(0, 27, 81, 0.6);
          }

          .sms-btn {
            width: 100px;
            height: 48px;
            background: #005dff;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: 500;
            line-height: 24px;
            letter-spacing: normal;

            &:disabled {
              background: #ccc;
              cursor: not-allowed;
            }
          }
        }

        .login-btn {
          width: 100%;
          height: 45px;
          background: #001b51;
          color: white;
          border: none;
          border-radius: 4px;
          margin-bottom: 24px;
          cursor: pointer;
        }

        .register-link {
          display: flex;
          justify-content: center;
          align-items: baseline;
          width: 100%;
          font-size: 18px;

          span {
            font-family: PingFang SC;
            font-size: 18px;
            font-weight: normal;
            line-height: 24px;
            letter-spacing: normal;
            color: #001b51;
          }

          .register-link-btn {
            font-family: PingFang SC;
            font-size: 18px;
            font-weight: 500;
            line-height: 24px;
            letter-spacing: normal;
            color: #005dff;
            text-decoration: none;
            background: none;
            border: none;
            cursor: pointer;
            vertical-align: baseline;
            margin-left: 4px;
          }
        }
      }

      .logged-in-content {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding: 25px;

        .user-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;

          .user-info {
            display: flex;
            align-items: center;

            .avatar {
              width: 60px;
              height: 60px;
              border-radius: 50%;
              background: #1890ff;
              color: white;
              font-size: 24px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 15px;
            }

            h3 {
              font-family: PingFang SC;
              font-size: 24px;
              font-weight: 500;
              line-height: 36px;
              letter-spacing: normal;
              color: #000000;
            }
          }

          .logout-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 93px;
            height: 36px;
            color: #001b51;
            background: rgba(0, 27, 81, 0.1);
            border: none;
            cursor: pointer;
          }
        }

        .order-dashboard {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
          margin-bottom: 20px;

          .order-item {
            background: white;
            padding: 10px;
            border-radius: 4px;

            .label {
              color: #666;
              font-size: 12px;
              margin-bottom: 5px;
            }

            .value {
              font-weight: bold;
              font-size: 25px;
              color: #333;
            }
          }
        }

        .action-buttons {
          display: flex;
          justify-content: space-between;

          .action-btn {
            width: 180px;
            height: 64px;
            background: #001b51;
            color: white;
            border: none;
            cursor: pointer;
            font-size: 16px;
          }

          .action-wed {
            width: 180px;
            height: 64px;
            background: white;
            color: #001b51;
            cursor: pointer;
            font-size: 16px;
            box-sizing: border-box;
            border: 1px solid #001b51;
          }
        }
      }
    }
  }
}
</style>
